"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var nacl = require("tweetnacl");
var pv_crypto_1 = require("./pv-crypto");
var util_1 = require("./util");
var elliptic = require('elliptic'), ecP256Context = new elliptic.ec('p256'), P256Curve = elliptic.curves.p256.curve, webcrypto = crypto.subtle, AES_TAG_LEN = 16, AES_IV_LEN = 12, PUB_KEY_LEN = 65, PBKDF2_ITERATIONS = 500000, PBKDF2_SALT_LEN = 12;
var FipsCryptoClass = /** @class */ (function () {
    function FipsCryptoClass() {
    }
    Object.defineProperty(FipsCryptoClass.prototype, "ivLength", {
        get: function () { return AES_IV_LEN; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FipsCryptoClass.prototype, "tagLength", {
        get: function () { return AES_TAG_LEN; },
        enumerable: true,
        configurable: true
    });
    FipsCryptoClass.prototype.generateSymmKey = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, webcrypto.generateKey({ name: 'AES-GCM', length: 256 }, true, ['encrypt', 'decrypt'])
                        .then(function (k) { return webcrypto.exportKey('raw', k); })
                        .then(function (k) { return new Uint8Array(k); })];
            });
        });
    };
    FipsCryptoClass.prototype.generateAsymmKey = function (usage) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                if (usage === pv_crypto_1.PVCryptoUsage.ENCRYPT) {
                    return [2 /*return*/, this.generateEncryptionKey()];
                }
                else {
                    return [2 /*return*/, this.generateSigningKey()];
                }
                return [2 /*return*/];
            });
        });
    };
    FipsCryptoClass.prototype.symmetricEncrypt = function (key, iv, plaintext) {
        return __awaiter(this, void 0, void 0, function () {
            var k, opts, result, _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, webcrypto.importKey('raw', key, 'AES-GCM', false, ['encrypt'])];
                    case 1:
                        k = _b.sent();
                        opts = { name: 'AES-GCM', iv: iv };
                        _a = Uint8Array.bind;
                        return [4 /*yield*/, webcrypto.encrypt(opts, k, plaintext)];
                    case 2:
                        result = new (_a.apply(Uint8Array, [void 0, _b.sent()]))();
                        // Return [ciphertext, tag]
                        return [2 /*return*/, [result.slice(0, -AES_TAG_LEN), result.slice(-AES_TAG_LEN)]];
                }
            });
        });
    };
    FipsCryptoClass.prototype.symmetricDecrypt = function (key, iv, tag, ciphertext) {
        return __awaiter(this, void 0, void 0, function () {
            var k, opts, _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, webcrypto.importKey('raw', key, 'AES-GCM', false, ['decrypt'])];
                    case 1:
                        k = _b.sent();
                        opts = { name: 'AES-GCM', iv: iv };
                        _a = Uint8Array.bind;
                        return [4 /*yield*/, webcrypto.decrypt(opts, k, util_1.concatArrays(ciphertext, tag))];
                    case 2: return [2 /*return*/, new (_a.apply(Uint8Array, [void 0, _b.sent()]))()];
                }
            });
        });
    };
    FipsCryptoClass.prototype.encryptWithPassphrase = function (passphrase, plaintext) {
        return __awaiter(this, void 0, void 0, function () {
            var salt, key, _a, ciphertext, tag;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        salt = util_1.randomBytes(PBKDF2_SALT_LEN);
                        return [4 /*yield*/, this.keyForPassphrase(passphrase, salt)];
                    case 1:
                        key = _b.sent();
                        return [4 /*yield*/, this.symmetricEncrypt(key, new Uint8Array(AES_IV_LEN).fill(0), plaintext)];
                    case 2:
                        _a = _b.sent(), ciphertext = _a[0], tag = _a[1];
                        return [2 /*return*/, util_1.concatArrays(salt, tag, ciphertext)];
                }
            });
        });
    };
    FipsCryptoClass.prototype.decryptWithPassphrase = function (passphrase, encryptedResult) {
        return __awaiter(this, void 0, void 0, function () {
            var salt, tag, ciphertext, key;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        salt = encryptedResult.slice(0, PBKDF2_SALT_LEN);
                        tag = encryptedResult.slice(PBKDF2_SALT_LEN, PBKDF2_SALT_LEN + AES_TAG_LEN);
                        ciphertext = encryptedResult.slice(PBKDF2_SALT_LEN + AES_TAG_LEN);
                        return [4 /*yield*/, this.keyForPassphrase(passphrase, salt)];
                    case 1:
                        key = _a.sent();
                        return [4 /*yield*/, this.symmetricDecrypt(key, new Uint8Array(AES_IV_LEN).fill(0), tag, ciphertext)];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    FipsCryptoClass.prototype.keyForPassphrase = function (passphrase, salt) {
        return __awaiter(this, void 0, void 0, function () {
            var key, keyBits;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, webcrypto.importKey('raw', new TextEncoder().encode(passphrase), 'PBKDF2', false, ['deriveBits'])];
                    case 1:
                        key = _a.sent();
                        return [4 /*yield*/, crypto.subtle.deriveBits({ name: 'PBKDF2', hash: 'SHA-512', salt: salt, iterations: PBKDF2_ITERATIONS }, key, 256)];
                    case 2:
                        keyBits = _a.sent();
                        return [2 /*return*/, new Uint8Array(keyBits)];
                }
            });
        });
    };
    FipsCryptoClass.prototype.sharedSecret = function (privateKey, publicKey, useFipsDerivation) {
        return __awaiter(this, void 0, void 0, function () {
            var naclSecret, p256PrivKey, p256PubKey, deriveParams, p256Secret, _a, combinedSecret, counter, _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        naclSecret = nacl.scalarMult(this.curve25519Part(privateKey), this.curve25519Part(publicKey));
                        return [4 /*yield*/, this.importP256PrivateKey(this.p256Part(privateKey), ['deriveBits'])];
                    case 1:
                        p256PrivKey = _c.sent();
                        return [4 /*yield*/, this.importP256PublicKey(this.p256Part(publicKey), [])];
                    case 2:
                        p256PubKey = _c.sent();
                        deriveParams = { name: 'ECDH', namedCurve: 'P-256', public: p256PubKey };
                        _a = Uint8Array.bind;
                        return [4 /*yield*/, webcrypto.deriveBits(deriveParams, p256PrivKey, 256)];
                    case 3:
                        p256Secret = new (_a.apply(Uint8Array, [void 0, _c.sent()]))();
                        if (useFipsDerivation) {
                            counter = Uint8Array.of(0, 0, 0, 1);
                            combinedSecret = util_1.concatArrays(counter, p256Secret, naclSecret);
                        }
                        else {
                            combinedSecret = util_1.concatArrays(naclSecret, p256Secret);
                        }
                        _b = Uint8Array.bind;
                        return [4 /*yield*/, webcrypto.digest({ name: 'SHA-256' }, combinedSecret)];
                    case 4: return [2 /*return*/, new (_b.apply(Uint8Array, [void 0, _c.sent()]))()];
                }
            });
        });
    };
    FipsCryptoClass.prototype.boxEncrypt = function (privateKey, publicKey, plaintext, useFipsDerivation) {
        return __awaiter(this, void 0, void 0, function () {
            var derivedKey, iv, _a, ciphertext, tag;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, this.sharedSecret(privateKey, publicKey, useFipsDerivation)];
                    case 1:
                        derivedKey = _b.sent();
                        iv = util_1.randomBytes(AES_IV_LEN);
                        return [4 /*yield*/, this.symmetricEncrypt(derivedKey, iv, plaintext)];
                    case 2:
                        _a = _b.sent(), ciphertext = _a[0], tag = _a[1];
                        return [2 /*return*/, util_1.concatArrays(iv, tag, ciphertext)];
                }
            });
        });
    };
    FipsCryptoClass.prototype.boxDecrypt = function (privateKey, publicKey, encryptedResult, useFipsDerivation) {
        return __awaiter(this, void 0, void 0, function () {
            var iv, tag, ciphertext, derivedKey;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        iv = encryptedResult.slice(0, AES_IV_LEN);
                        tag = encryptedResult.slice(AES_IV_LEN, AES_IV_LEN + AES_TAG_LEN);
                        ciphertext = encryptedResult.slice(AES_IV_LEN + AES_TAG_LEN);
                        return [4 /*yield*/, this.sharedSecret(privateKey, publicKey, useFipsDerivation)];
                    case 1:
                        derivedKey = _a.sent();
                        return [4 /*yield*/, this.symmetricDecrypt(derivedKey, iv, tag, ciphertext)];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    FipsCryptoClass.prototype.hybridEncrypt = function (publicKey, plaintext, useFipsDerivation) {
        return __awaiter(this, void 0, void 0, function () {
            var _a, ephemeralPrivateKey, ephemeralPublicKey, symmetricKey, useIV, iv, _b, ciphertext, tag;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0: return [4 /*yield*/, this.generateEncryptionKey()];
                    case 1:
                        _a = _c.sent(), ephemeralPrivateKey = _a[0], ephemeralPublicKey = _a[1];
                        return [4 /*yield*/, this.sharedSecret(ephemeralPrivateKey, publicKey, useFipsDerivation)];
                    case 2:
                        symmetricKey = _c.sent();
                        useIV = useFipsDerivation;
                        iv = useIV ? util_1.randomBytes(AES_IV_LEN) : new Uint8Array(AES_IV_LEN).fill(0);
                        return [4 /*yield*/, this.symmetricEncrypt(symmetricKey, iv, plaintext)];
                    case 3:
                        _b = _c.sent(), ciphertext = _b[0], tag = _b[1];
                        return [2 /*return*/, useIV ? util_1.concatArrays(ephemeralPublicKey, iv, tag, ciphertext) : util_1.concatArrays(ephemeralPublicKey, tag, ciphertext)];
                }
            });
        });
    };
    FipsCryptoClass.prototype.hybridDecrypt = function (privateKey, encryptedResult, useFipsDerivation) {
        return __awaiter(this, void 0, void 0, function () {
            var ephemeralPublicKey, useIV, ivLength, iv, tag, ciphertext, symmetricKey;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        ephemeralPublicKey = encryptedResult.slice(0, PUB_KEY_LEN);
                        useIV = useFipsDerivation;
                        ivLength = useIV ? AES_IV_LEN : 0;
                        iv = useIV ? encryptedResult.slice(PUB_KEY_LEN, PUB_KEY_LEN + ivLength) : new Uint8Array(AES_IV_LEN).fill(0);
                        tag = encryptedResult.slice(PUB_KEY_LEN + ivLength, PUB_KEY_LEN + ivLength + AES_TAG_LEN);
                        ciphertext = encryptedResult.slice(PUB_KEY_LEN + ivLength + AES_TAG_LEN);
                        return [4 /*yield*/, this.sharedSecret(privateKey, ephemeralPublicKey, useFipsDerivation)];
                    case 1:
                        symmetricKey = _a.sent();
                        return [2 /*return*/, this.symmetricDecrypt(symmetricKey, iv, tag, ciphertext)];
                }
            });
        });
    };
    FipsCryptoClass.prototype.generateEncryptionKey = function () {
        return __awaiter(this, void 0, void 0, function () {
            var curve25519Key, _a, p256Private, p256Public;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        curve25519Key = nacl.box.keyPair();
                        return [4 /*yield*/, this.generateP256Key(pv_crypto_1.PVCryptoUsage.ENCRYPT)];
                    case 1:
                        _a = _b.sent(), p256Private = _a[0], p256Public = _a[1];
                        return [2 /*return*/, [util_1.concatArrays(curve25519Key.secretKey, p256Private),
                                util_1.concatArrays(curve25519Key.publicKey, p256Public)]];
                }
            });
        });
    };
    FipsCryptoClass.prototype.generateSigningKey = function () {
        return __awaiter(this, void 0, void 0, function () {
            var curve25519Seed, curve25519Key, _a, p256Private, p256Public;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        curve25519Seed = util_1.randomBytes(32);
                        curve25519Key = nacl.sign.keyPair.fromSeed(curve25519Seed);
                        return [4 /*yield*/, this.generateP256Key(pv_crypto_1.PVCryptoUsage.SIGN)];
                    case 1:
                        _a = _b.sent(), p256Private = _a[0], p256Public = _a[1];
                        return [2 /*return*/, [util_1.concatArrays(curve25519Seed, p256Private),
                                util_1.concatArrays(curve25519Key.publicKey, p256Public)]];
                }
            });
        });
    };
    FipsCryptoClass.prototype.generateP256Key = function (usage) {
        return __awaiter(this, void 0, void 0, function () {
            var prefix, key, jwkKey, privateKeyBytes, uncompressedPublicKey, publicKeyBytes;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        prefix = new Uint8Array([0x04]);
                        if (!(usage === pv_crypto_1.PVCryptoUsage.ENCRYPT)) return [3 /*break*/, 2];
                        return [4 /*yield*/, webcrypto.generateKey({ name: 'ECDH', namedCurve: 'P-256' }, true, ['deriveBits'])];
                    case 1:
                        key = _a.sent();
                        return [3 /*break*/, 4];
                    case 2: return [4 /*yield*/, webcrypto.generateKey({ name: 'ECDSA', namedCurve: 'P-256' }, true, ['sign'])];
                    case 3:
                        key = _a.sent();
                        _a.label = 4;
                    case 4: return [4 /*yield*/, webcrypto.exportKey('jwk', key.privateKey)];
                    case 5:
                        jwkKey = _a.sent();
                        privateKeyBytes = util_1.b64Decode(jwkKey.d);
                        uncompressedPublicKey = util_1.concatArrays(prefix, util_1.b64Decode(jwkKey.x), util_1.b64Decode(jwkKey.y));
                        publicKeyBytes = P256Curve.decodePoint(uncompressedPublicKey).encodeCompressed();
                        return [2 /*return*/, [privateKeyBytes, new Uint8Array(publicKeyBytes)]];
                }
            });
        });
    };
    FipsCryptoClass.prototype.sign = function (privateKey, message) {
        return __awaiter(this, void 0, void 0, function () {
            var naclKey, naclSig, p256Key, signature;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        naclKey = nacl.sign.keyPair.fromSeed(this.curve25519Part(privateKey));
                        naclSig = nacl.sign.detached(message, naclKey.secretKey);
                        return [4 /*yield*/, this.importP256PrivateKey(this.p256Part(privateKey), ['sign'])];
                    case 1:
                        p256Key = _a.sent();
                        return [4 /*yield*/, webcrypto.sign({ name: 'ECDSA', hash: { name: 'SHA-256' } }, p256Key, message)];
                    case 2:
                        signature = _a.sent();
                        return [2 /*return*/, util_1.concatArrays(naclSig, new Uint8Array(signature))];
                }
            });
        });
    };
    FipsCryptoClass.prototype.verify = function (publicKey, message, signature) {
        return __awaiter(this, void 0, void 0, function () {
            var naclSig, p256Key, p256Sig;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        naclSig = signature.slice(0, 64);
                        if (!nacl.sign.detached.verify(message, naclSig, this.curve25519Part(publicKey))) {
                            return [2 /*return*/, false];
                        }
                        return [4 /*yield*/, this.importP256PublicKey(this.p256Part(publicKey), ['verify'])];
                    case 1:
                        p256Key = _a.sent();
                        p256Sig = signature.slice(64);
                        return [2 /*return*/, webcrypto.verify({ name: 'ECDSA', hash: { name: 'SHA-256' } }, p256Key, p256Sig, message)];
                }
            });
        });
    };
    FipsCryptoClass.prototype.publicKeyFromPrivate = function (privateKey, usage) {
        return __awaiter(this, void 0, void 0, function () {
            var curve25519Bytes, curve25519Key, p256PrivKey, p256Key;
            return __generator(this, function (_a) {
                curve25519Bytes = this.curve25519Part(privateKey);
                if (usage === pv_crypto_1.PVCryptoUsage.SIGN) {
                    curve25519Key = nacl.sign.keyPair.fromSeed(curve25519Bytes).publicKey;
                }
                else {
                    curve25519Key = nacl.box.keyPair.fromSecretKey(curve25519Bytes).publicKey;
                }
                p256PrivKey = ecP256Context.keyFromPrivate(this.p256Part(privateKey));
                p256Key = p256PrivKey.getPublic(true, 'binary');
                return [2 /*return*/, util_1.concatArrays(curve25519Key, p256Key)];
            });
        });
    };
    // First 32 bytes are Curve25519
    FipsCryptoClass.prototype.curve25519Part = function (keyBytes) {
        return keyBytes.slice(0, 32);
    };
    // Second part (after 32 bytes) is P-256
    FipsCryptoClass.prototype.p256Part = function (keyBytes) {
        return keyBytes.slice(32);
    };
    FipsCryptoClass.prototype.importP256PrivateKey = function (keyBytes, usages) {
        return __awaiter(this, void 0, void 0, function () {
            var privKey, pubKeyPoint;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        privKey = ecP256Context.keyFromPrivate(keyBytes);
                        pubKeyPoint = privKey.getPublic();
                        return [4 /*yield*/, webcrypto.importKey('jwk', {
                                kty: 'EC',
                                crv: 'P-256',
                                x: util_1.b64Encode(pubKeyPoint.getX().toArrayLike(Uint8Array, 'be', 32), true),
                                y: util_1.b64Encode(pubKeyPoint.getY().toArrayLike(Uint8Array, 'be', 32), true),
                                d: util_1.b64Encode(keyBytes, true)
                            }, { name: this.algorithmName(usages), namedCurve: 'P-256' }, false, usages)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    FipsCryptoClass.prototype.importP256PublicKey = function (keyBytes, usages) {
        return __awaiter(this, void 0, void 0, function () {
            var point;
            return __generator(this, function (_a) {
                point = P256Curve.decodePoint(keyBytes);
                return [2 /*return*/, webcrypto.importKey('jwk', {
                        kty: 'EC',
                        crv: 'P-256',
                        x: util_1.b64Encode(point.getX().toArrayLike(Uint8Array, 'be', 32), true),
                        y: util_1.b64Encode(point.getY().toArrayLike(Uint8Array, 'be', 32), true)
                    }, { name: this.algorithmName(usages), namedCurve: 'P-256' }, false, usages)];
            });
        });
    };
    FipsCryptoClass.prototype.algorithmName = function (usages) {
        return usages.includes('sign') || usages.includes('verify') ? 'ECDSA' : 'ECDH';
    };
    return FipsCryptoClass;
}());
exports.FipsCryptoClass = FipsCryptoClass;
exports.FipsCrypto = new FipsCryptoClass();
